// Action Types
export const TAGS_ACTION_TYPES = {
  SET_TAGS_DATA: "SET_TAGS_DATA",
  UPDATE_TAG_CHILDREN: "UPDATE_TAG_CHILDREN",
  SET_ERROR: "SET_ERROR",
  SET_PAGINATION: "SET_PAGINATION",
  SET_SELECTED_TAB_TYPE: "SET_SELECTED_TAB_TYPE",
  SET_AVAILABLE_TAB_TYPES: "SET_AVAILABLE_TAB_TYPES",
  SET_COUNTS_LOADING: "SET_COUNTS_LOADING",
  SET_TAG_TYPE_PAGINATION: "SET_TAG_TYPE_PAGINATION",
  REMOVE_TAG: "REMOVE_TAG",
  UPDATE_TAG: "UPDATE_TAG",
};

export const setTagsData = (tags) => ({
  type: TAGS_ACTION_TYPES.SET_TAGS_DATA,
  payload: tags,
});

export const updateTagChildren = (tagId, children) => ({
  type: TAGS_ACTION_TYPES.UPDATE_TAG_CHILDREN,
  payload: { tagId, children },
});

export const setError = (error) => ({
  type: TAGS_ACTION_TYPES.SET_ERROR,
  payload: error,
});

export const setPagination = (pagination) => ({
  type: TAGS_ACTION_TYPES.SET_PAGINATION,
  payload: pagination,
});

export const setSelectedTabType = (tabType) => ({
  type: TAGS_ACTION_TYPES.SET_SELECTED_TAB_TYPE,
  payload: tabType,
});

export const setAvailableTabTypes = (tabTypes) => ({
  type: TAGS_ACTION_TYPES.SET_AVAILABLE_TAB_TYPES,
  payload: tabTypes,
});

export const setCountsLoading = (loading) => ({
  type: TAGS_ACTION_TYPES.SET_COUNTS_LOADING,
  payload: loading,
});

export const setTagTypePagination = (tagType, pagination) => ({
  type: TAGS_ACTION_TYPES.SET_TAG_TYPE_PAGINATION,
  payload: { tagType, pagination },
});

export const removeTag = (tagId) => ({
  type: TAGS_ACTION_TYPES.REMOVE_TAG,
  payload: tagId,
});

export const updateTag = (entityTag) => ({
  type: TAGS_ACTION_TYPES.UPDATE_TAG,
  payload: entityTag,
});
